import { message } from 'ant-design-vue'
/**
 *  获取菜单配置
 *  @param { Object } menu 后台生成的菜单对象
 */
export const getMenuConfig = menu => {
  let cfg = {}
  try {
    cfg = JSON.parse(menu.moduleConfig) || {}
  } catch (error) { }
  return cfg
}

/**
 *  判断是否为空值（undefined, null）
 *  @param {any} value 需要判断的值
 */
export const isEmpty = (value, varNaN = false) => {
  return (varNaN && isNaN(+value)) || [undefined, null, ''].includes(value)
}

/**
 *  时间日期格式化
 *  @param {string} str 时间字符串或时间对象
 *  @param {string} format 时间显示格式，默认'YYYY-MM-DD HH:mm:ss'
 *  @param {string} errMsg 时间格式化错误返回的内容，默认空''
 */
export const formatDate = (str, format = 'YYYY-MM-DD HH:mm:ss', errMsg = '') => {
  if (!isEmpty(str)) {
    return moment(str).format(format)
  }
  return errMsg
}

/**
 *  判断用户是否拥有权限
 *  @param {string} funcCode 权限编码，add 添加 / update 修改 / delete 删除
 *  @param {string} menuFunction 权限列表（后台系统中接收到的同名prop）
 */
export const authority = (funcCode = '', menuFunction = []) => {
  return menuFunction.some(fun => fun.funcCode === funcCode)
}

/**
 *  ant-select 组件通用搜索方法
 *  - 组件无法使用 options 进行配置生成，需要手动构建 a-select-option 节点
 *  - 需要在 a-select-option 节点上声明 data-search 参数，值为筛选值数组
 *  @example <a-select-option :data-search="[userId, userName]" >{{ label }}</a-select-option>
 *           则此时可以通过 userId 或 userName 的值进行搜索
 *  @param { String } ipt 用户输入
 *  @param { Object } option 选择项
 *  @param { Function } callback 其他的搜索方式
 */
export const selectFilterOption = (ipt, option, callback) => {
  try {
    return (
      option.data.attrs['data-search'].some(val =>
        String(val)
          .toLocaleLowerCase()
          .includes((ipt || '').toLocaleLowerCase())
      ) ||
      (typeof callback === 'function' && callback())
    )
  } catch (error) {
    return false
  }
}

/**
 *  替换对象中的key
 *  @param { Object } obj 数据对象
 *  @param { Object } replaceFieldsConfig 替换字段配置 { [newField]: oldField }
 *  @param { Boolean } delOldFields 是否删除原字段，默认不删除 false
 *  @returns { Object } 返回新的数据对象
 */
export const replaceFields = (obj = {}, replaceFieldsConfig = {}, delOldFields = false) => {
  const nObj = Object.assign({}, obj)
  for (const field in replaceFieldsConfig) {
    if (Object.hasOwnProperty.call(replaceFieldsConfig, field)) {
      const replaceField = replaceFieldsConfig[field]
      nObj[field] = nObj[replaceField]
      if (delOldFields) {
        delete nObj[replaceField]
      }
    }
  }
  return nObj
}

export const debounce = (func, wait, immediate = true) => {
  let timeout
  return function () {
    const that = this
    if (timeout) clearTimeout(timeout)
    if (immediate) {
      var callNow = !timeout
      timeout = setTimeout(() => {
        timeout = null
      }, wait)
      if (callNow) func.apply(this, arguments)
    } else {
      timeout = setTimeout(function () {
        func.apply(that, arguments)
      }, wait)
    }
  }
}

/**
 *  自动匹配文件大小单位
 *  @param { Array } obj 数据数组
 *  @param { Function } iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */
export const size2Str = (size) => {
  if (size < 1024) {
    return size + 'B'
  } else if (size >= 1024 && size < Math.pow(1024, 2)) {
    return parseFloat(size / 1024).toFixed(2) + 'KB'
  } else if (size >= Math.pow(1024, 2) && size < Math.pow(1024, 3)) {
    return parseFloat(size / Math.pow(1024, 2)).toFixed(2) + 'MB'
  } else if (size > Math.pow(1024, 3)) {
    return parseFloat(size / Math.pow(1024, 3)).toFixed(2) + 'GB'
  } else {
    return 0 + 'B'
  }
}

// 插入字符串
export const insertStr = (oldStr, addItem, afterWhich) => {
  // 在指定字符串后面添加指定字符串
  var strArr = oldStr.split('')
  strArr.splice(oldStr.indexOf(afterWhich) + afterWhich.length, 0, addItem)
  return strArr.join('')
}

// 字典管理提取
export const fieldExtraction = (dictionary, userRole) => {
  // 1. 初始化分组后的 options 和复合键映射表
  const groupedOptions = {}
  const compositeKeyToNameMap = {}

  // 2. 遍历数据，生成分组和复合键映射表
  dictionary.forEach(item => {
    if (item.parentId && item.enumValue && item.name) {
      // const compositeKey = `${item.parentId}_${item.enumValue}`
      const compositeKey = `${item.enumValue}`

      // 创建复合键到 name 的映射
      compositeKeyToNameMap[compositeKey] = item.name

      // 分组数据
      if (!groupedOptions[item.parentId]) {
        groupedOptions[item.parentId] = {
          label: `${item.parentName}`,
          options: []
        }
      }

      if (!(userRole.roleCode === 'city' && ['provinceUnassigned', 'ignore'].indexOf(item.enumValue) !== -1)) {
        groupedOptions[item.parentId].options.push({
          ...item,
          label: item.name,
          value: item.enumValue
        })
      }
    }
  })

  // const selectOptions = Object.values(groupedOptions)

  return [groupedOptions, compositeKeyToNameMap]
}

export const getNameByCompositeKey = (compositeKeyToNameMap, parentId, enumValue) => {
  const compositeKey = `${parentId}_${enumValue}`
  return compositeKeyToNameMap[compositeKey] || null
}

export const getButtonPermissions = (status, taskTimeStatus, isProvince) => {
  // 逾期的判断
  /**
   * 1: 查看；2：下发；3：撤回；4：删除; 5: 恢复; 6: 复制单号
   */
  // if (taskTimeStatus === 'late') return [1]
  const permissionsMap = {
    cityUnassigned: isProvince ? [1, 3, 6] : [1, 2, 6, 7],
    processing: isProvince ? [1, 3, 6] : [1, 6],
    provinceUnassigned: isProvince ? [1, 2, 4, 6] : [1, 2, 6],
    provinceAuditReject: isProvince ? [1, 6] : [1, 2, 6],
    ignore: isProvince ? [1, 5, 6] : [1, 5, 6]
  }

  // 默认权限列表（只有查看）
  return permissionsMap[status] || [1]
}

export const getMinTime = (timeStrings) => {
  if (!timeStrings || timeStrings.length === 0) return null

  // 去掉数组中为undefinded的，且过滤时间小于当前时间的
  const filteredTimeStrings = timeStrings.filter(time => time !== undefined)

  if (filteredTimeStrings.length === 0) return null
  // 将时间字符串转换为 moment 对象并排序
  const sortedTimes = filteredTimeStrings.map(time => moment(time)).sort((a, b) => a - b)

  // 返回最小时间的字符串形式
  return sortedTimes[0].format() // 或者使用原始格式
}

export const disabledDate = (current) => {
  // Can not select days before today and today
  return current && current < moment().endOf('day')
}

export const disabledDateTime = () => {
  return {
    disabledHours: () => range(0, 24).splice(4, 20),
    disabledMinutes: () => range(30, 60),
    disabledSeconds: () => [55, 56]
  }
}

function range (start, end) {
  const result = []
  for (let i = start; i < end; i++) {
    result.push(i)
  }
  return result
}

export const copyId = async (row) => {
  try {
    // 使用 document.execCommand 方式
    const textarea = document.createElement('textarea')
    textarea.value = row.taskNumber
    document.body.appendChild(textarea)
    textarea.select()
    const success = document.execCommand('copy')
    document.body.removeChild(textarea)

    if (success) {
      message.success('复制成功')
    } else {
      message.error('复制失败')
    }
  } catch (err) {
    // 如果 execCommand 失败，尝试 clipboard API
    try {
      await navigator.clipboard.writeText(row.taskNumber)
      message.success('复制成功')
    } catch (clipboardErr) {
      message.error('复制失败')
    }
  }
}
